export const apiBaseUrl = "https://api.dev.perfitrocks.com";
// export const apiBaseUrl = "http://localhost:3007";
// export const apiBaseUrl = "http://dev.api.perfitrocks.com:8086";

export const captchaSiteKey = "6LftdSIpAAAAAJk5dFnY7TS9SPSt802iwmFAAuG4";

// Use this secret key for communication between your site and reCAPTCHA.
// 6LftdSIpAAAAAHzNpByUK-Lmf7HyKt2MzwbtcO7G
